import React, { useState, useEffect, useContext} from 'react';
import MUIDataTable from 'mui-datatables';
import { Link as RouterLink } from 'react-router-dom';
// material
import {
    Card,
    Stack,
    Alert,
    Button,
    Container,
    Typography,
    MenuItem,  
    ListItemIcon, 
    ListItemText,
    AlertTitle
  } from '@mui/material';

import { ThemeProvider } from '@mui/material/styles';
import Theme from '../../components/Button';  

import {api, reiniciarToken, consEmpresa, excluirEmpresa} from '../../services/api';
// context
import { AuthContext } from '../../contexts/auth';  

import Page from '../../components/Page';
import Iconify from '../../components/Iconify';

export default function ConsultaEmpresa() {
  
  const { logout } = useContext(AuthContext);
  const [dados, setData] = useState([]);

  const getEmpresas = async () => {
    
    const retorno = await reiniciarToken();
    if(retorno.erro === true) {
      if (retorno.mensagem === 'O Token é inválido!' || retorno.mensagem === 'Acesso negado!'){
        logout();
      }
    }else{
      localStorage.setItem("token", retorno.data.token);
      api.defaults.headers.Authorization = `Bearer ${retorno.data.token}`;
    }

    const response = await consEmpresa();
    if(response.erro === true) {
      if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
        logout();
      }
    }else {
      response.data.forEach((valores) => {
        
        let descricaoTipoComercio;  
        
        if (valores.tipo_comercio === 1) {
          descricaoTipoComercio = "Empresa de Serviços"
        }else if (valores.tipo_comercio === 2){
          descricaoTipoComercio = "Restaurante/Lanchonete"
        }else if (valores.tipo_comercio === 3){
          descricaoTipoComercio = "Lojas em Geral"
        }else if (valores.tipo_comercio === 4){
          descricaoTipoComercio = "Empresas com Vendas/Despesa Venda"
        }else if (valores.tipo_comercio === 5){ 
          descricaoTipoComercio = "Agências de Viagem" 
        }else{
          descricaoTipoComercio = "Outros"
        };

        setData(dados => [...dados, {id_empresa: valores.id_empresa,
                                     descricao: valores.descricao, 
                                     contato: valores.contato,
                                     telefone_celular: valores.telefone_celular,
                                     tipo_comercio: descricaoTipoComercio}]);
      });
    }; 
  }

  useEffect(() => {
    getEmpresas();
  },[]) 

  const [status, setStatus] = useState({
    type: '',
    mensagem: ''
  }) 
  
  
  const excluiEmpresas = async (id) => {
    const response = await excluirEmpresa(id);

    if(response.erro === true) {
      if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
        logout();
      }else {
        setStatus({
          type: "erro",
          mensagem: response.mensagem
        })
      }
    }else {
      setStatus({
        type: "success",
        mensagem: response.data.mensagem
      })
      setData([]);
      getEmpresas();
    }; 
  } 

  const columns = [{name: "Ação",
                    options: {
                      filter: false,
                      sort: false,
                      empty: true,
                      customBodyRenderLite: (dataIndex, rowIndex) =>  {
                        return (
                          <> 
                            <MenuItem onClick={() => excluiEmpresas(dados[dataIndex].id_empresa)} sx={{ color: 'text.secondary' }}>
                              <ListItemIcon>
                                  <Iconify icon="eva:trash-2-outline" width={24} height={24} />
                              </ListItemIcon>
                              <ListItemText primary="Excluir" primaryTypographyProps={{ variant: 'body2' }} />
                            </MenuItem>

                            <MenuItem component={RouterLink} to={`/empresas/editar/${dados[dataIndex].id_empresa}`} sx={{ color: 'text.secondary' }}>
                              <ListItemIcon>
                                  <Iconify icon="eva:edit-fill" width={24} height={24} />
                              </ListItemIcon>
                              <ListItemText primary="Alterar" primaryTypographyProps={{ variant: 'body2' }} />
                            </MenuItem>
                          </> 
                        );
                      }
                    }
                  }
                  ,{name:"descricao", label: "Descrição"} 
                  ,{name:"contato", label: "Contato"} 
                  ,{name:"telefone_celular", label: "Telefone Celular"}
                  ,{name:"tipo_comercio", label: "Tipo Comércio"}
                  ];

  const options = {
    filterType: "dropdown",
    tableBodyHeight: "100%",
    selectableRows: "none",
    responsive: "standard",
  };             
                    
  return (
    <Page title="Mesa">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Consulta de Empresas
          </Typography>
          <ThemeProvider theme={Theme}>
            <Button variant="contained" color="neutral" component={RouterLink} to="/empresas/cadastrar" startIcon={<Iconify icon="eva:plus-fill" />}>
              Nova Empresa
            </Button>
          </ThemeProvider>
        </Stack>
        <Card>
            <Stack spacing={3}>
              {status.type === 'erro' ? <Alert severity="error"><AlertTitle>Erro</AlertTitle>{status.mensagem}</Alert> : ""}
              {status.type === 'success' ? <Alert severity="success"><AlertTitle>Sucesso</AlertTitle>{status.mensagem}</Alert> : ""}
            </Stack > 
            <MUIDataTable
                data={Object.values(dados)}
                columns={columns}  
                options={options} 
            />
        </Card>
      </Container>  
    </Page>  
  );
}

